import {AfterViewInit, Component, ContentChildren, input, OnInit, QueryList, ViewChild} from '@angular/core';
import {NgbCollapse, NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';
import {SidebarMenuItemComponent} from '../sidebar-menu-item/sidebar-menu-item.component';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-sidebar-menu',
  standalone: true,
  imports: [NgbCollapseModule],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.scss'
})
export class SidebarMenuComponent implements OnInit, AfterViewInit {
  @ViewChild("collapse", {static: true}) collapse: NgbCollapse;
  name = input.required();
  icons = input();
  routerActiveUrl = input<string>();
  routerActiveOnClick = input<boolean>(false);
  isCollapsed = true;
  currentUrl: string;
  @ContentChildren(SidebarMenuItemComponent) itemComponents!: QueryList<SidebarMenuItemComponent>;

  constructor(private router: Router) {
    this.routerActiveUrl();
    this.currentUrl = this.router.url;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log(`SidebarMenuComponent prevUrl: ${this.currentUrl} currentUrl: ${event.url}`);
        this.currentUrl = event.url;
      }
    });
  }

  ngOnInit(): void {
    if (this.currentUrl?.startsWith(this.routerActiveUrl())) {
      this.isCollapsed = false;
    }
  }

  ngAfterViewInit(): void {

  }

  click() {
    this.collapse.toggle();
    if (!this.isCollapsed && this.routerActiveOnClick() && !this.currentUrl?.startsWith(this.routerActiveUrl())) {
      this.router.navigate([this.routerActiveUrl()]);
    }
  }
}
